import {OrderAmounts} from '../../classes/order_amounts'
import {OrderUnits} from '../../classes/order_units'
import {OrderDetail} from '../../classes/order_detail'
import {PromotionDetail} from '../../classes/promotion_detail'

/**
 * 
 * @param {*} state 
 * @param {OrderDetail} detail 
 */
export function addOrUpdateOrderDetail(state, detail) {
   let det = state.order_details.find(f => f.product_id === detail.product_id)
   if(det){
      OrderDetail.copyData(detail, det)
   }
   else {
      state.order_details.push(detail)
   }
   state.last_updated_at = Date.now
 }

 export function removeOrderDetailForProduct(state, product_id) {
   state.order_details = state.order_details.filter(f => f.product_id != product_id)
   state.last_updated_at = Date.now
 }

 /**
  * Update cart amounts
  * @param {*} state 
  * @param {OrderAmounts} amounts 
  */
export function updateAmounts(state, amounts) {
   state.amounts = amounts
}

/**
 * Update cart units
 * @param {*} state 
 * @param {OrderUnits} units 
 */
export function updateUnits(state, units) {
   state.units = {
      pieces: units.pieces,
      boxes: units.boxes,
   }
}

/**
 * 
 * @param {*} state 
 * @param {PromotionDetail} detail 
 */
export function addPromotionDetail(state, detail) {
   state.promotion_details = state.promotion_details.filter(f => f.promotion_id != detail.promotion_id)
   state.promotion_details.push(detail)
   state.last_updated_at = Date.now
 }

 export function removePromotionDetailForPromo(state, promotion_id) {
   state.promotion_details = state.promotion_details.filter(f => f.promotion_id != promotion_id)
   state.last_updated_at = Date.now
 }

  /**
  * Update cart amounts
  * @param {*} state 
  * @param {PromoOrderAmounts} amounts 
  */
export function updatePromoAmounts(state, amounts) {
   state.promo_amounts = amounts
}

 export function cleanCart(state) {
   state.order_details = []
   state.promotion_details = []
   state.started_at = null
   state.last_updated_at = null
   state.amounts = {
      subtotal: 0,
      ieps: 0,
      iva: 0,
      tax: 0,
      after_tax_total: 0,
      discount: 0,
      final_total: 0,
   }

   state.promo_amounts = {
      subtotal: 0,
      subtotal_order_lines: 0,
      ieps: 0,
      iva: 0,
      tax: 0,
      after_tax_total: 0,
      discount: 0,
      final_total: 0,
   },
   
   state.units = {
      pieces: 0,
      boxes: 0,
   }
 }

 export function setOrderNotes(state, notes) {
   state.order_notes = notes
 }